import { ADICIONAR_FILTRO_MAPA_VEICULO } from '../../actions/types'

const initialState = undefined;

export default function reducerAdicionarFiltroMapaVeiculo (state = '', action = initialState) {
  switch (action.type) {
    case ADICIONAR_FILTRO_MAPA_VEICULO: {
      return action.payload
    }

    default:
      return state
  }
}
